var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, attachKey2click, SvgIcon, Popup } from "survey-react-ui";
import { QuestionAdornerComponent } from "./Question";
import { AddQuestionButtonComponent } from "../AddQuestionButton";
var PanelAdornerComponent = /** @class */ (function (_super) {
    __extends(PanelAdornerComponent, _super);
    function PanelAdornerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PanelAdornerComponent.prototype.renderElementPlaceholder = function () {
        var _this = this;
        if (!this.model.isEmptyElement) {
            return null;
        }
        return (React.createElement("div", { className: "svc-panel__placeholder_frame-wrapper" },
            React.createElement("div", { className: "svc-panel__placeholder_frame" },
                React.createElement("div", { className: "svc-panel__placeholder" }, this.model.placeholderText),
                this.model.showAddQuestionButton ? attachKey2click(React.createElement("div", { className: "svc-panel__add-new-question svc-action-button", onClick: function (e) {
                        e.stopPropagation();
                        _this.model.addNewQuestion();
                    } },
                    React.createElement(SvgIcon, { className: "svc-panel__add-new-question-icon", iconName: "icon-add_24x24", size: "auto" }),
                    React.createElement("span", { className: "svc-add-new-item-button__text" }, this.model.addNewQuestionText))) : null)));
    };
    PanelAdornerComponent.prototype.disableTabStop = function () {
        return true;
    };
    PanelAdornerComponent.prototype.renderFooter = function () {
        return (React.createElement(React.Fragment, null,
            !this.model.isEmptyElement && this.model.element.isPanel && this.model.showAddQuestionButton ? (React.createElement("div", { className: "svc-panel__add-new-question-container" },
                React.createElement("div", { className: "svc-panel__question-type-selector-popup" },
                    React.createElement(Popup, { model: this.model.questionTypeSelectorModel.popupModel })),
                React.createElement("div", { className: "svc-panel__add-new-question-wrapper" },
                    React.createElement(AddQuestionButtonComponent, { item: { data: this.model }, buttonClass: "svc-action-button", renderPopup: false })))) : null,
            _super.prototype.renderFooter.call(this)));
    };
    return PanelAdornerComponent;
}(QuestionAdornerComponent));
export { PanelAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-panel", function (props) {
    return React.createElement(PanelAdornerComponent, props);
});
